// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button {
  background-color: #8fddd3;
  font-family: IBM Plex Mono;
  font-weight: 700;
  text-transform: uppercase;
  padding: 12px 18px;
  border-radius: 4px;
  border: solid 2px #121212;
  box-shadow: 4px 4px #121212;
  transition: transform 50ms,
  box-shadow 50ms;
}
button:hover{
  transform: translate(2px, 2px);
  box-shadow: 2px 2px #121212;
}

.button-container button {
  background-color: #8fddd3;
  font-family: IBM Plex Mono;
  font-weight: 700;
  text-transform: uppercase;
  padding: 12px 18px;
  border-radius: 4px;
  border: solid 2px #121212;
  box-shadow: 4px 4px #121212;
  transition: transform 50ms,
  box-shadow 50ms;
  pointer-events: none;
  cursor: default;
}
.button-container button:hover{
  transform: translate(2px, 2px);
  box-shadow: 2px 2px #121212;
}

.container-about{
  border: solid 2px #121212;
  transition: transform 50ms;
  width: 70%;
  max-width: 800px;
  min-width: 320px;
  font-family: IBM Plex Mono;
  padding: 20px;

  background: rgb(255, 255, 255);
}

.container-about-info-prof {
  border: solid 2px #121212;
  transition: transform 50ms;
  width: 50%;
  max-width: 700px;
  min-width: 220px;
  font-family: IBM Plex Mono;
  padding: 20px;
  margin: 0 auto;

  background: rgb(255, 255, 255);
}

.container-about.expanded {
  max-width: 800px;
  padding: 20px 30px;
}

.br-m{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
}

.input-stl{
  border-radius: 50px;
  border-style: none;
  outline: none;
  display: flex;
  padding-left: 20px;
  padding-right: 20px;
  margin: 0 auto;
  padding: 12px 24px;
  max-width: 300px;
}

.link-acc {
  color: #000000;
  text-decoration: none;
  transform: translate(2px, 2px);
  box-shadow: 2px 2px #121212;
  border-style: none;
  outline: none;
  display: flex;
  padding-left: 20px;
  padding-right: 20px;
  margin: 0 auto;
  padding: 12px 24px;
}

.link-acc:hover {
  text-decoration: underline;
}

.invalid-fop-container {
  border: 1px solid #ddd;
  margin-bottom: 15px;
  border-radius: 5px;
  overflow: hidden;
}

.invalid-fop-header {
  background-color: #f5f5f5;
  padding: 10px 15px;
  cursor: pointer;
}

.invalid-fop-details {
  padding: 15px;
}

.download-button {
  background-color: #2196F3;
  color: white;
  padding: 8px 15px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: 15px;
}

.download-button:hover {
  background-color: #1976D2;
}

.status-buttons {
  display: flex;
  gap: 10px;
  justify-content: center;
}

.status-button.processed {
  background-color: #90EE90;
  color: white;
  border: none;
  padding: 8px 15px;
  border-radius: 4px;
  cursor: pointer;
}

.status-button.cancelled {
  background-color: #FF6B6B;
  color: white;
  border: none;
  padding: 8px 15px;
  border-radius: 4px;
  cursor: pointer;
}

.status-button.processed:hover {
  background-color: #32CD32;
}

.status-button.cancelled:hover {
  background-color: #DC143C;
}

.download-button {
  background-color: #ffffff;
  color: rgb(0, 0, 0);

  border: 2px solid #000000;
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: 15px;
  transition: background-color 0.3s ease;
}

.download-button:hover {
  background-color: #e6f3ff;
}

.details-button {
  background-color: #ffa500;
}`, "",{"version":3,"sources":["webpack://./src/components/profile/Profile.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;EAC3B;iBACe;AACjB;AACA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;EAC3B;iBACe;EACf,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,aAAa;;EAEb,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,aAAa;EACb,cAAc;;EAEd,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,8BAA8B;EAC9B,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;;EAEnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["button {\r\n  background-color: #8fddd3;\r\n  font-family: IBM Plex Mono;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  padding: 12px 18px;\r\n  border-radius: 4px;\r\n  border: solid 2px #121212;\r\n  box-shadow: 4px 4px #121212;\r\n  transition: transform 50ms,\r\n  box-shadow 50ms;\r\n}\r\nbutton:hover{\r\n  transform: translate(2px, 2px);\r\n  box-shadow: 2px 2px #121212;\r\n}\r\n\r\n.button-container button {\r\n  background-color: #8fddd3;\r\n  font-family: IBM Plex Mono;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  padding: 12px 18px;\r\n  border-radius: 4px;\r\n  border: solid 2px #121212;\r\n  box-shadow: 4px 4px #121212;\r\n  transition: transform 50ms,\r\n  box-shadow 50ms;\r\n  pointer-events: none;\r\n  cursor: default;\r\n}\r\n.button-container button:hover{\r\n  transform: translate(2px, 2px);\r\n  box-shadow: 2px 2px #121212;\r\n}\r\n\r\n.container-about{\r\n  border: solid 2px #121212;\r\n  transition: transform 50ms;\r\n  width: 70%;\r\n  max-width: 800px;\r\n  min-width: 320px;\r\n  font-family: IBM Plex Mono;\r\n  padding: 20px;\r\n\r\n  background: rgb(255, 255, 255);\r\n}\r\n\r\n.container-about-info-prof {\r\n  border: solid 2px #121212;\r\n  transition: transform 50ms;\r\n  width: 50%;\r\n  max-width: 700px;\r\n  min-width: 220px;\r\n  font-family: IBM Plex Mono;\r\n  padding: 20px;\r\n  margin: 0 auto;\r\n\r\n  background: rgb(255, 255, 255);\r\n}\r\n\r\n.container-about.expanded {\r\n  max-width: 800px;\r\n  padding: 20px 30px;\r\n}\r\n\r\n.br-m{\r\n  display: flex;\r\n  flex-direction: row;\r\n  flex-wrap: wrap;\r\n  justify-content: center;\r\n}\r\n\r\n.input-stl{\r\n  border-radius: 50px;\r\n  border-style: none;\r\n  outline: none;\r\n  display: flex;\r\n  padding-left: 20px;\r\n  padding-right: 20px;\r\n  margin: 0 auto;\r\n  padding: 12px 24px;\r\n  max-width: 300px;\r\n}\r\n\r\n.link-acc {\r\n  color: #000000;\r\n  text-decoration: none;\r\n  transform: translate(2px, 2px);\r\n  box-shadow: 2px 2px #121212;\r\n  border-style: none;\r\n  outline: none;\r\n  display: flex;\r\n  padding-left: 20px;\r\n  padding-right: 20px;\r\n  margin: 0 auto;\r\n  padding: 12px 24px;\r\n}\r\n\r\n.link-acc:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.invalid-fop-container {\r\n  border: 1px solid #ddd;\r\n  margin-bottom: 15px;\r\n  border-radius: 5px;\r\n  overflow: hidden;\r\n}\r\n\r\n.invalid-fop-header {\r\n  background-color: #f5f5f5;\r\n  padding: 10px 15px;\r\n  cursor: pointer;\r\n}\r\n\r\n.invalid-fop-details {\r\n  padding: 15px;\r\n}\r\n\r\n.download-button {\r\n  background-color: #2196F3;\r\n  color: white;\r\n  padding: 8px 15px;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.download-button:hover {\r\n  background-color: #1976D2;\r\n}\r\n\r\n.status-buttons {\r\n  display: flex;\r\n  gap: 10px;\r\n  justify-content: center;\r\n}\r\n\r\n.status-button.processed {\r\n  background-color: #90EE90;\r\n  color: white;\r\n  border: none;\r\n  padding: 8px 15px;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n}\r\n\r\n.status-button.cancelled {\r\n  background-color: #FF6B6B;\r\n  color: white;\r\n  border: none;\r\n  padding: 8px 15px;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n}\r\n\r\n.status-button.processed:hover {\r\n  background-color: #32CD32;\r\n}\r\n\r\n.status-button.cancelled:hover {\r\n  background-color: #DC143C;\r\n}\r\n\r\n.download-button {\r\n  background-color: #ffffff;\r\n  color: rgb(0, 0, 0);\r\n\r\n  border: 2px solid #000000;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  margin-bottom: 15px;\r\n  transition: background-color 0.3s ease;\r\n}\r\n\r\n.download-button:hover {\r\n  background-color: #e6f3ff;\r\n}\r\n\r\n.details-button {\r\n  background-color: #ffa500;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
